import cn from 'classnames';
import { useSelector } from 'react-redux';
import { Button, Element, Icon, IconButton } from 'src/components';
import { useModal } from 'src/hooks/useModal';
import { isMiniappSelector } from 'src/selectors/app';
import CopyLinkButton from '../CopyLinkButton';
import ZaloShareButton from '../ZaloShareButton';
import FacebookButton from '../FacebookButton';
import styles from './styles.module.scss';

interface IProps {
    url: string;
    shareUrl: string;
    title: string;
    className?: string;
}
const ShareButton = ({ url, shareUrl, className, title }: IProps) => {
    const { Modal, show, hide } = useModal({ fromBottom: true });
    const isMiniapp = useSelector(isMiniappSelector);

    const handleClickShare = () => {
        show();
    };

    const handleClick = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
    };
    return (
        <>
            <IconButton
                title="Lưu tin"
                icon="share"
                text="Chia sẻ"
                onClick={handleClickShare}
                className={className}
            />
            <Modal
                className={cn(
                    styles['share-modal'],
                    'w-full h-full',
                    'm-0 px-[15px]',
                    'bg-transparent'
                )}
            >
                <Element
                    onClick={handleClick}
                    className={styles['modal-share']}
                >
                    <Element className={styles['share-title']}>Chia sẻ</Element>
                    <Element className={styles['share-list']}>
                        <CopyLinkButton
                            className="px-[15px]"
                            link={url}
                            hide={hide}
                        />
                        <ZaloShareButton
                            hide={hide}
                            link={shareUrl}
                            title={title}
                            className="px-[15px]"
                        >
                            <Icon type="bm" icon="zalo"></Icon>
                            <Element renderAs="span">Chia sẻ Zalo</Element>
                        </ZaloShareButton>
                        {!isMiniapp && (
                            <FacebookButton
                                className={cn(
                                    styles['btn-facebook'],
                                    'px-[15px]'
                                )}
                                hide={hide}
                                link={shareUrl}
                                title={title}
                            >
                                <Icon type="bm" icon="facebook" />
                                <Element renderAs="span">
                                    Chia sẻ Facebook
                                </Element>
                            </FacebookButton>
                        )}

                        <Button
                            title="Đóng"
                            className={cn(
                                'flex items-center justify-center',
                                'py-[12px] mt-[10px]',
                                'w-full',
                                'text-[1.6rem] font-semibold',
                                'border-t border-solid border-[#ebebeb]'
                            )}
                            onClick={hide}
                        >
                            Đóng
                        </Button>
                    </Element>
                </Element>
            </Modal>
        </>
    );
};

export default ShareButton;
